<template>
  <b-container fluid class='container-form-reset-password'>
      <Form-new-password :conten="formulario"></Form-new-password>
  </b-container>
</template>
<script>

import FormNewPassword from '../../components/forms/Form-new-password.vue';

    export default {
        name: 'NewPassword',
        components: {
            FormNewPassword
        },
        props: {
            content: Object
        },
        mounted: () => {},
        data: () => ({
            form: {
                password: null,
                confirm_password: null
            }
        }),
        validations: {
        },
        methods: {
        }
    }
</script>
<style scoped>
.container-form-reset-password{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  }
</style>